import type { Answers } from '../types/assessmentQuestion';

/**
 * Coerce an answer value to a single string. Multi-select (checkbox) answers are
 * `string[]` and `repeatingList` answers are `RepeatingListRow[]`, but the
 * consumers that call this — the legacy assigned-screener payload,
 * pre-diabetes, PHQ/GAD — are ALL single-select and never actually receive
 * either. This exists only to satisfy the widened `Answers` value type at
 * those call sites: a `string[]`'s first value is taken (as before); a
 * `RepeatingListRow[]` has no sensible single-string reading, so it falls
 * back to `''` rather than stringifying a row object.
 */
export function toSingleAnswerValue(value: Answers[string]): string {
  if (!Array.isArray(value)) return value;
  const [first] = value;
  return typeof first === 'string' ? first : '';
}
